/*
 * Copyright (c) 2021. Manchester Economic Forecasting Limited <http://mef-uk.com>
 */

import * as React from 'react';
import { makeStyles, Tab, Tabs, Tooltip, Typography } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import Info from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles(() => ({
	container: {
		display: 'flex',
		justifyContent: 'center',
	},
}));

const Header = (): JSX.Element => {
	const styles = useStyles();

	const routes = [
		'/',
		'/macro',
		'/esg',
		'/emissions',
		'/emissions-breakdown',
		'/trade-links',
		'/topic-links',
		'/monte-carlo',
		'/mcqs',
		'/glossary',
		'/monte-carlo-ghg',
		'/ghg-firms'
	];

	const { pathname } = useLocation();

	return (
		<div className={styles.container}>
			<Tabs variant="scrollable" value={pathname !== '/' ? pathname : false}>
				<Tab
					value={routes[0]}
					label={
						<Tooltip title="Information about specific Tabs in this MEF App">
							<Info fontSize="small" />
						</Tooltip>
					}
					style={{ backgroundColor: '#F8F8F8', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[0]}
				/>
				<Tab
					value={routes[1]}
					label={
						<Tooltip title="View Global Macroeconomic Impacts of Shocks">
							<Typography variant="body1">Macro</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(84,77,160,0.025)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[1]}
				/>
				<Tab
					value={routes[2]}
					label={
						<Tooltip title="View Global Environmental/ESG Impacts of Shocks">
							<Typography variant="body1">ESG-ECO</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(46,139,87,0.2)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[2]}
				/>
				<Tab
					value="/sunburst"
					label={
						<Tooltip title="View interactive Glossary of Economic/ESG Terms">
							<Typography variant="body1">GHG-Sunburst</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(46,139,87,0.2)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to="/sunburst"
				/>
				<Tab
					value={routes[4]}
					label={
						<Tooltip title="Drilldown into major GHG by Country/Sector over time">
							<Typography variant="body1">GHG-Sectors</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(46,139,87,0.2)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[4]}
				/>
				<Tab
					value={routes[11]}
					label={
						<Tooltip title="Drilldown into major GHG by Corporates/Brand over time">
							<Typography variant="body1">GHG-Firms</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(46,139,87,0.2)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[11]}
				/>
				<Tab
					value={routes[3]}
					label={
						<Tooltip title="View evolution of GHG stocks by Country by GHG gas">
							<Typography variant="body1">GHG-Stocks</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(46,139,87,0.2)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[3]}
				/>
				<Tab
					value={routes[10]}
					label={
						<Tooltip title="MonteCarlo to show the race to net zero emissions">
							<Typography variant="body1">GHG-MonteCarlo</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(46,139,87,0.2)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[10]}
				/>
				<Tab
					value={'/portfolio'}
					label={
						<Tooltip title="Visualise the environmental impact of your investment portfolio">
							<Typography variant="body1">ESG-Portfolio</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(46,139,87,0.2)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={'/portfolio'}
				/>
				<Tab
					value={routes[5]}
					label={
						<Tooltip title="View Top20 Export & Import Partners for each Country">
							<Typography variant="body1">Links-Trade</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(84,77,160,0.05)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[5]}
				/>
				<Tab
					value={routes[6]}
					label={
						<Tooltip title="View Macroeconomic model Links from shocked variables">
							<Typography variant="body1">Links-Macro</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(84,77,160,0.10)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[6]}
				/>
				<Tab
					value={routes[7]}
					label={
						<Tooltip title="View Montecarlo risk fans around several portfolios for different macro shocks">
							<Typography variant="body1">Montecarlo</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(84,77,160,0.15)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[7]}
				/>
				<Tab
					value={routes[8]}
					label={
						<Tooltip title="View MCQ tests related to the course textbook & specific to selected shocks">
							<Typography variant="body1">MCQ</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(84,77,160,0.20)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[8]}
				/>
				<Tab
					value={routes[9]}
					label={
						<Tooltip title="View interactive Glossary of Economic/ESG Terms">
							<Typography variant="body1">Glossary</Typography>
						</Tooltip>
					}
					style={{ backgroundColor: 'rgba(84,77,160,0.25)', color: '#786c3a', fontWeight: 'bold' }}
					component={Link}
					to={routes[9]}
				/>
			</Tabs>
		</div>
	);
};

export default Header;
